<template>
	<div>
        <div>Code</div>

		<p><b>Données de test</b></p>

		<ace_editor :height="300" mode="json" :code="data_test" @update="update_code($event, 'data_test')"/>

		<div class="d-flex align-items-center mb-1">
			<b><span class="mr-2">Code</span></b>
			<b-button size="sm" variant="outline-secondary" @click="toggleDocPanel" :title="showDocPanel ? 'Masquer la documentation' : 'Documentation du code'">
				<i class="fas fa-question-circle"></i> Documentation
			</b-button>
		</div>

		<div class="script-editor-container" :class="{ 'script-editor-with-doc': showDocPanel }">
			<div class="script-ace-wrapper">
				<ace_editor ref="code_editor" :height="500" :code="code" @update="update_code($event, 'code')"/>
			</div>
			<div v-if="showDocPanel" class="script-doc-panel">
				<div class="d-flex justify-content-between align-items-center mb-2">
					<strong style="font-size:0.9em">Documentation</strong>
					<b-button size="sm" variant="link" class="p-0" @click="showDocPanel = false"><i class="fas fa-times"></i></b-button>
				</div>
				<p class="script-doc-fonctionnement">
					Le code est exécuté dans un processus isolé (bac à sable vm2) : pas de <code>require()</code>/<code>import</code>, pas d'accès au système de fichiers, limité à 10% CPU / 50 Mo / 30 secondes.<br>
					Le résultat affiché dans « Résultats » est la valeur de la <strong>dernière expression évaluée</strong> par votre code (comme dans une console) : terminez votre script par la valeur que vous voulez inspecter (une variable, un objet, ou <code>JSON.stringify(...)</code>).<br>
					Le nom exact d'une clé de sécurité existante (Credentials, ex: <code>chatgpt_key</code>) écrit tel quel dans le code ou dans les données de test est automatiquement remplacé par sa valeur déchiffrée avant l'exécution.<br>
					<code>async</code>/<code>await</code> sont tolérés par le bac à sable mais le résultat n'est pas attendu avant d'être renvoyé : préférez les fonctions synchrones ci-dessous (<code>sync_request</code>, <code>database</code>, <code>sleep</code>) à des promesses.
				</p>
				<b-form-input v-model="docFilter" size="sm" placeholder="Filtrer..." class="mb-2" />
				<div v-for="section in filteredDocSections" :key="section.key" class="mb-3">
					<div class="script-doc-section-title">{{ section.label }}</div>
					<div
						v-for="item in section.items"
						:key="item.name"
						class="script-doc-item"
						@click="insertAtCursor(item.snippet)"
						:title="'Insérer : ' + item.snippet">
						<code class="script-doc-item-name">{{ item.name }}</code>
						<small class="text-muted script-doc-item-desc">{{ item.description }}</small>
					</div>
				</div>
			</div>
		</div>

		<b-button v-if="_canExecuteCode" @click="test">Test</b-button>
		<test_as_user @change="onTestUserChange"></test_as_user>

		<p><b>Résultats</b></p>

		<p>{{ results }}</p>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";

	import obj_editor from "../components/obj_editor.vue";
	import ace_editor from "../components/ace_editor.vue";
	import test_as_user from "../components/TestAsUser.vue";
	import code from "../services/code.js"
	import store from "../store";

	var clone = require("clone");

	export default {
		name: "execution_code",
		components: {
			obj_editor,
			ace_editor,
			test_as_user
		},
		props: {			library: { type: Boolean, default: false },
			name: { type: String, default: null },
			version: { type: [String, Number], default: null }		},
		data() {
			return {
                id: uniqueId(""),
                
				code: "",
				data_test: "{}",
				results: "",
				test_user: null,
				showDocPanel: false,
				docFilter: ""
			};
		},
		computed: {
			_canExecuteCode() {
				return !store.state.user.rules || !!store.state.user.rules.code_execution;
			},
			docSections() {
				return [
					{
						key: "variables",
						label: "Variables",
						items: [
							{ name: "(vos clés)", snippet: "", description: "Il n'y a PAS de variable « data » : chaque clé de premier niveau de vos « Données de test » (JSON ci-dessus) devient directement une variable globale du script. Ex: si vos données de test sont {\"foo\": 1}, la variable s'appelle « foo », pas « data.foo »." },
							{ name: "user", snippet: "user", description: "Utilisateur qui exécute ce test (vous, ou l'utilisateur simulé via « Tester en tant que ») : identifiant, nom, prenom, rules... (sans mot de passe/jwt/token). Variable directe, PAS data.user." }
						]
					},
					{
						key: "libs",
						label: "Fonctions et bibliothèques",
						items: [
							{ name: "_", snippet: "_", description: "Underscore.js — _.map, _.filter, _.groupBy, _.find..." },
							{ name: "console", snippet: "console.log()", description: "console.log/console.error — n'apparaît nulle part dans cette interface (pas de remontée de logs), utile uniquement en debug côté serveur." },
							{ name: "sync_request()", snippet: "sync_request('GET', 'https://...').getBody('utf8')", description: "Requête HTTP synchrone (lib sync-request)." },
							{ name: "sleep.sleep()", snippet: "sleep.sleep(1)", description: "Attendre N secondes (bloquant)." },
							{ name: "database()", snippet: "database('SELECT * FROM ma_table WHERE id = ?', [42])", description: "Requête SQL synchrone sur la base du client courant (même portée que le bloc « Base de données ») — retourne un tableau de lignes, lève une erreur si la requête échoue." }
						]
					}
				];
			},
			filteredDocSections() {
				var filter = (this.docFilter || "").toLowerCase().trim();
				if (!filter) return this.docSections;
				return this.docSections.map(function(section) {
					return Object.assign({}, section, {
						items: section.items.filter(function(item) {
							return item.name.toLowerCase().includes(filter) || item.description.toLowerCase().includes(filter);
						})
					});
				}).filter(function(section) { return section.items.length > 0; });
			}
		},
		watch: {
		},
		methods: {
			async load(data)
			{
				var self = this;

				this.code = data.code;
				this.data_test = data.data_test;
			},
			async save()
			{				
				return {
					data_db: {
					},
					code: this.code,
					data_test: this.data_test
				}
			},
			async update_code(code, key)
			{
				this[key] = code;
			},
			onTestUserChange(test_user)
			{
				this.test_user = test_user;
			},
			toggleDocPanel()
			{
				this.showDocPanel = !this.showDocPanel;
			},
			insertAtCursor(snippet)
			{
				if (this.$refs.code_editor)
					this.$refs.code_editor.insert(snippet);
			},
			async test()
			{
				if (!this._canExecuteCode)
					return;
				this.results = "";
				this.results = await code.code(this.code, this.data_test, this.test_user ? this.test_user.jwt : null);
			}
		},
		mounted: async function () {
		},
	};
</script>

<style>
.script-editor-container {
	width: 100%;
	height: 500px;
	display: inline-block;
	position: relative;
}
.script-editor-with-doc {
	display: flex !important;
	gap: 8px;
	align-items: flex-start;
}
.script-ace-wrapper {
	width: 100%;
	height: 100%;
	position: relative;
}
.script-editor-with-doc .script-ace-wrapper {
	flex: 1;
	min-width: 0;
	height: 100%;
}
.script-doc-panel {
	width: 320px;
	flex-shrink: 0;
	height: 500px;
	overflow-y: auto;
	border: 1px solid #dee2e6;
	border-radius: 4px;
	padding: 8px;
	font-size: 0.82em;
	background: #fff;
}
.script-doc-fonctionnement {
	font-size: 0.85em;
	color: #495057;
	background: #f8f9fa;
	border: 1px solid #dee2e6;
	border-radius: 4px;
	padding: 8px;
}
.script-doc-section-title {
	font-weight: 600;
	padding: 2px 0 3px 0;
	border-bottom: 1px solid #dee2e6;
	margin-bottom: 3px;
	color: #495057;
	font-size: 0.95em;
}
.script-doc-item {
	padding: 3px 4px;
	cursor: pointer;
	border-radius: 3px;
	display: flex;
	flex-direction: column;
	gap: 1px;
	margin-bottom: 1px;
}
.script-doc-item:hover {
	background-color: #e9ecef;
}
.script-doc-item-name {
	color: #0366d6;
	font-size: 0.88em;
	word-break: break-all;
}
.script-doc-item-desc {
	color: #6c757d;
	font-size: 0.85em;
	line-height: 1.3;
}
</style>
